import React from 'react';

import { ListItemIcon } from '@mui/material';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

import { FontAwesomeSvgIcon } from '../../index';
import { DataGridAction } from '../DataGrid';

interface Props {
  action: DataGridAction;
  params: GridRenderCellParams;
  onCloseMenu: () => void;
}

export const CustomDataGridActionMenuItem: React.FC<Props> = ({
  action,
  params,
  onCloseMenu
}) => {
  const tooltip =
    typeof action.tooltipTitle === 'function'
      ? action.tooltipTitle(params.id, params.row)
      : action.tooltipTitle;
  const icon =
    typeof action.icon === 'function'
      ? action.icon(params.id, params.row)
      : action.icon;

  return (
    <MenuItem
      title={tooltip}
      onClick={() => {
        action.onClick(params.id, params.row);
        onCloseMenu();
      }}
    >
      <ListItemIcon>
        <FontAwesomeSvgIcon icon={icon} fontSize="small" />
      </ListItemIcon>
      <ListItemText>{tooltip}</ListItemText>
    </MenuItem>
  );
};
